import { format as formatDate } from 'date-fns';
import React from 'react';

export interface ActivityItemData {
  completedAt: string;
  label: string;
  icon?: React.ElementType;
  onClick?: () => void;
}

export const ActivityList: React.FC<{ items: ActivityItemData[] }> = ({
  items,
}) => {
  return (
    <div className="grid grid-cols-[auto_1fr] gap-x-4 gap-y-2 items-center">
      {items.map((item, i) => (
        <ActivityItem key={i} {...item} />
      ))}
    </div>
  );
};

export const ActivityItem: React.FC<ActivityItemData> = ({
  completedAt,
  label,
  icon: Icon,
  onClick,
}) => {
  const formattedCompletedAt = completedAt
    ? formatDate(new Date(completedAt), 'M/d @ h:mm a')
    : '';
  return (
    <>
      <span className="text-sm font-medium text-neutral-600 whitespace-nowrap">
        {formattedCompletedAt}
      </span>
      <div className="flex items-center gap-2 min-w-0">
        <span
          className={`text-sm text-gray-600 truncate ${onClick ? 'cursor-pointer hover:text-gray-800' : ''}`}
          onClick={onClick}
        >
          {label}
        </span>
        {Icon && (
          <span className="flex-shrink-0 cursor-pointer" onClick={onClick}>
            <Icon
              size={18}
              className="text-primary hover:text-primary-700 transition-colors"
            />
          </span>
        )}
      </div>
    </>
  );
};
